// extracted by css-extract-rspack-plugin
export default {"BetaLabel":"ArrayField-module__BetaLabel__MCg5N"};